import React, { useRef } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import "./ContactSection.css";
import logoEmblem from "../assets/OMO-Logo-Emblem.svg";

function ContactSection() {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ej6mdo7", // e.g. service_abcd123
        "template_xvir2jd", // e.g. template_xyzw456
        formRef.current,
        "qHmoFm29uRAzYYY-n" // e.g. 2Hj8o6Q_ABC123
      )
      .then(
        () => {
          Swal.fire({
            title: "Success!",
            text: "Your message has been sent successfully.",
            icon: "success",
            confirmButtonColor: "#ed448d"
          });
          formRef.current.reset();
        },
        (error) => {
          Swal.fire({
            title: "Oops...",
            text: "Something went wrong. Please try again later.",
            icon: "error",
            confirmButtonColor: "#ed448d"
          });
        }
      );
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-content">
        <div className="contact-left">
          <div className="contact-heading">
            <div className="contact-icons">
              <img
                src={logoEmblem}
                alt="OMO Logo Emblem"
                className="contact-logo-icon"
              />
            </div>
            <h2>
              Ready to Navigate <br /> Your Brand’s Success Journey?
            </h2>
          </div>
        </div>
        <div className="contact-right">
          <h3 className="say-hello">
            Say{" "}
            <span className="hello-colored">
              <span style={{ color: "#f28aa6" }}>H</span>
              <span style={{ color: "#ed448d" }}>e</span>
              <span style={{ color: "#f6953d" }}>l</span>
              <span style={{ color: "#f28aa6" }}>l</span>
              <span style={{ color: "#ed448d" }}>o</span>
            </span>
          </h3>
          <form ref={formRef} onSubmit={sendEmail} className="contact-form">
            <input type="text" name="name" placeholder="First or Last Name" required />
            <input type="email" name="email" placeholder="Email" required />
            <textarea name="message" placeholder="Thoughts" rows="4" required />
            <button type="submit">
              LET’S COLLABORATE <span className="arrow">↗</span>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
